import { AbstractControl, ValidationErrors } from "@angular/forms";
import { UtilCommon } from "app/shared/common/utils/UtilCommon";

export const validateEmail = (control: AbstractControl): ValidationErrors | null  => {
    if (!UtilCommon.validateEmail(control.value)) {
        return { 'emailInvalid': true };
    }
    return null;
}